import { AfterContentInit, Component, EventEmitter, Input, Output } from "@angular/core";

type inputType = "color" | "date" | "datetime-local" | "email" | "month" | "number" | "password" | "tel" | "text" | "time" | "week" | "url";

type iconPosition = "left" | "right";

type autoCompleteType = "on" | "off";

@Component({
    selector: "mobi-office-lib-input-field",
    templateUrl: "./input-field.component.html",
    styleUrls: ["./input-field.component.scss"],
    standalone: false
})
export class InputFieldComponent implements AfterContentInit {
  ngAfterContentInit(): void {
    this.name = this.generateRandomString();
  }

  name: string = "";

  @Input({ required: true }) label: string = "";
  @Input() labelClass: string = "";
  @Input() model: any;
  @Input() placeholder: string = "";
  @Input() subText: string = "";
  @Input() subTextClass: string = "";
  @Input() autocomplete: autoCompleteType = "off";
  @Input() disabled: boolean = false;
  @Input() max: string = "9999999";
  @Input() maxLength: string = "9999999";
  @Input() min: string = "0";
  @Input() minLength: string = "0";
  @Input() readOnly: boolean = false;
  @Input() type: inputType = "text";
  @Input() isRequired: boolean = false;
  @Input() isTextArea: boolean = false;
  @Input() textAreaRows: number = 2;

  // ICON
  @Input() iconPath: string = "";
  @Input() iconPosition: iconPosition = "left";
  @Input() iconAltText: string = "input-icon";
  @Input() iconClass: string = "";

  @Output() modelChange = new EventEmitter();
  @Output() changeEmitter = new EventEmitter();
  @Output() blurEmitter = new EventEmitter();
  @Output() focusEmitter = new EventEmitter();
  @Output() keyupEmitter = new EventEmitter();
  @Output() keydownEmitter = new EventEmitter();
  @Output() enterEmitter = new EventEmitter();
  @Output() iconEmitter = new EventEmitter();

  onModelChange($event: any) {
    this.modelChange.emit(this.model);
  }

  onChange($event: any) {
    this.changeEmitter.emit($event);
  }

  onBlur($event: any) {
    this.blurEmitter.emit($event);
  }

  onFocus($event: any) {
    this.focusEmitter.emit($event);
  }

  onKeyUp($event: any) {
    this.keyupEmitter.emit($event);
  }

  onKeyDown($event: any) {
    this.keydownEmitter.emit($event);
  }

  onEnter($event: any) {
    this.enterEmitter.emit($event);
  }

  onIcon($event: any) {
    this.iconEmitter.emit($event);
  }

  private generateRandomString() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 20; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    return result;
  }
}
